module.exports = __webpack_public_path__ + "img/charging-hub-definitive-semipublic.f0ca02b0.png";